export enum InProgressSelection {
  my = 'my',
  all = 'all',
}
